import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetHotParamsSchema = ActionCommonParamsSchema.extend({
    query: z.string().optional(),
    count: z.number().optional(),
});

export type DouyinGetHotParams = z.infer<typeof DouyinGetHotParamsSchema>;
